import React, {useEffect} from "react";
import {campaignFormActions} from "../../../store/actions/campaignFormAction";
import {connect} from "react-redux";
import {useForm} from "react-hook-form";
import ReactHookFormChipInput from "../../input/ReactHookFormChipInput";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton, useTheme} from "@mui/material";
import useCustomStyles from "../../utils/UseCustomStyles";

const customStyles = (theme) => ({
    root: {
        marginTop: theme.spacing(1),
        padding: "12px 10px",
        backgroundColor: theme.palette.background.darkBlue,
        borderRadius: 4
    },
    title: {
        paddingTop: 4,
        fontSize: 14,
        fontWeight: 600
    },
    radio: {
        '&$checked': {
            color: theme.palette.error.light
        }
    },
    checked: {},
    deleteButton: {
        color: theme.palette.error.dark
    },
    addConditionButton: {
        textTransform: "none",
        padding: "2px 8px"
    }
});

function Referrer(props) {
    const theme = useTheme();
    const classes = useCustomStyles(customStyles, theme);
    const {campaignFormState: {flow, selectedRuleNumber, selectedRule}} = props;

    const {control, setValue, reset, getValues} = useForm({
        defaultValues: {
            referrerCondition: "is",
            referrerIncludeEmptyValue: false,
            referrerValues: []
        }
    });

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    useEffect(() => {
        let condition = selectedRule?.conditions?.referrer?.condition;
        if (condition === undefined || condition === "") {
            reset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRule, selectedRuleNumber, selectedRule?.conditions?.referrer?.condition]);

    useEffect(() => {
        let type = flow?.rules[selectedRuleNumber]?.conditions?.referrer;
        if (selectedRule !== null && type?.condition !== "") {
            setValue("referrerCondition", type?.condition);
            setValue("referrerIncludeEmptyValue", type?.includeEmptyValue);
            setValue("referrerValues", type?.values !== null ? type?.values : []);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRuleNumber, selectedRule, flow.rules]);

    const updateCondition = () => {
        props.updateCondition(
            props.campaignFormState.selectedRuleNumber,
            "referrer",
            getValues("referrerCondition"),
            getValues("referrerIncludeEmptyValue"),
            getValues("referrerValues")
        );
    };

    const removeCondition = () => {
        props.updateCondition(props.campaignFormState.selectedRuleNumber, "referrer", "", false, null);
    };

    const addCondition = () => {
        props.updateCondition(props.campaignFormState.selectedRuleNumber, "referrer", "is", false, []);
    };

    const renderAddCondition = () => {
        let condition = selectedRule?.conditions?.referrer?.condition;
        if (condition === "" || condition === undefined) {
            return (
                <Box display="flex" flexDirection="row">
                    <Box flexGrow={1} className={classes?.title}>
                        <span>Referrer</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            className={classes?.addConditionButton}
                            onClick={addCondition}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        let condition = selectedRule?.conditions?.referrer?.condition;
        if (condition !== "" && condition !== undefined) {
            return (
                <>
                    <Box mb={1} display="flex" flexDirection="row">
                        <Box flexGrow={1} className={classes?.title}>Referrer</Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size={"small"}
                                className={classes?.deleteButton}
                                onClick={removeCondition}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            defaultValue="is"
                            control={control}
                            options={radioConditions}
                            name="referrerCondition"
                            label="conditions"
                            updateOnChange={updateCondition}
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="referrerIncludeEmptyValue"
                            updateOnChange={updateCondition}
                        />
                    </Box>
                    <Box mt={1}>
                        <ReactHookFormChipInput
                            control={control}
                            values={getValues("referrerValues")}
                            name="referrerValues"
                            label="Referrer"
                            updateOnChange={updateCondition}
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <Box display="flex" flexDirection="column" className={classes?.root}>
            {renderAddCondition()}
            {renderConditionBox()}
        </Box>
    );
}

const mapStateToProps = (state) => ({
    campaignFormState: state.campaignForm,
});

const mapDispatchToProps = {
    updateCondition: campaignFormActions.updateCondition,
};

export default connect(mapStateToProps, mapDispatchToProps)(Referrer);